import { render, staticRenderFns } from "./EventsMain.vue?vue&type=template&id=3b772342&"
import script from "./EventsMain.vue?vue&type=script&lang=js&"
export * from "./EventsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports